export default __webpack_public_path__ + "static/media/ic_eth_16.7879704b.svg";